<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.ImageTextOverlapSlice>());
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-bounded','pa-ito', { 'pa-ito--secondary': slice.variation === 'secondary' }]"
  >
    <div class="pa-container">
      <div class="pa-ito__layout">
        <!-- Image -->
        <div class="pa-ito__image">
          <PrismicImage
              v-if="slice.primary.image?.url"
              :field="slice.primary.image"
          />
        </div>

        <!-- Text content -->
        <div class="pa-ito__content">
          <div v-if="slice.primary.eyebrow" class="pa-ito__content-eyebrow">
            {{ slice.primary.eyebrow }}
          </div>
          <div class="pa-ito__content-title">
            <PrismicRichText :field="slice.primary.title" />
          </div>
          <div class="pa-ito__content-card">
            <PrismicRichText :field="slice.primary.description" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
